module.exports = __webpack_public_path__ + "img/Microsopy_background.5aedaa3f.jpg";